import type { ConsentResponse } from "@/core/types";

import { isACPEligibleCarrier } from "./isACPEligibleCarrier";

type GetACPStatusParams = {
  consentResponse: ConsentResponse;
  insuranceCarrier?: string;
};

export function getACPStatus({ consentResponse, insuranceCarrier }: GetACPStatusParams) {
  const isEligible = isACPEligibleCarrier(insuranceCarrier);

  if (!isEligible) return "NOT_ELIGIBLE";

  switch (consentResponse) {
    case true:
      return "OPTED_IN";

    case false:
      return "OPTED_OUT";

    case null:
      return "NOT_RESPONDED";

    /* The default return when the user didn't have a chance to respond to the consent */
    default:
      return "NOT_RESPONDED";
  }
}
